import React from 'react';
import SignatureForm from './SignatureForm';

export default class AdditionalForm extends React.Component {
  constructor(props) {
    super();
    this.state = {
    }
    this.child = React.createRef();
  };

  //创建附加表单
  createAdditionalForm() {
    switch (this.props.additionalForm) {
      case 'SignatureForm':
        return <div className='additional-form-div mt-2'><SignatureForm ref={this.child} {...this.props} /></div>;
      default:
        return <></>;
    }
  }

  render() {
    return (
      <>{this.createAdditionalForm()}</>
    );
  }
}
